module.exports = __webpack_public_path__ + "static/kendra-beckley-abeec71f1ee62ee48a29067904a7f020.png";